// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`InputTip test Match con el snapshot 1`] = `
<div class="container">
    <div class="inner-component"></div>
    <!---->
</div>
`;
